import {Component, OnInit} from '@angular/core';
import {StzhComponentsAngularModule} from '@oiz/stzh-components-angular';

@Component({
    selector: 'app-kontakt',
    templateUrl: './kontakt.component.html',
    styleUrls: ['./kontakt.component.css'],
    imports: [StzhComponentsAngularModule],
    standalone: true
})
export class KontaktComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
